import { lodChlsProps } from "interface/rm/crr";
import { ReactNode, createContext, useContext, useState } from "react";

// set Month Context
interface CalendarContextType {
  now: Date;
  setNow: (now: Date) => void;
}

const CalendarContext = createContext<CalendarContextType | undefined>(
  undefined
);

interface CalendarProviderProps {
  children: ReactNode;
}

export const CalendarProvider = ({ children }: CalendarProviderProps) => {
  const [now, setNow] = useState(new Date());

  return (
    <CalendarContext.Provider value={{ now, setNow }}>
      {children}
    </CalendarContext.Provider>
  );
};

export const useCalendarContext = (): CalendarContextType => {
  const context = useContext(CalendarContext);

  if (!context) {
    throw new Error(
      "useCalendarContext는 CalendarProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};

// set CalendarCard Context
export type cardInfProps =
  | (lodChlsProps["rmPdList"][number] & {
      sellDt?: string;
      lodChlCd?: string;
    })
  | null;

interface CalendarCardInfContextType {
  cardInf: cardInfProps;
  setCardInf: (inf: cardInfProps) => void;
  btnTyp: string;
  setBtnTyp: (btnTyp: string) => void;
}

const CalendarCardInfContext = createContext<
  CalendarCardInfContextType | undefined
>(undefined);

interface CalendarCardInfProviderProps {
  children: ReactNode;
}

export const CalendarCardInfProvider = ({
  children,
}: CalendarCardInfProviderProps) => {
  const [cardInf, setCardInf] = useState<cardInfProps>(null);
  const [btnTyp, setBtnTyp] = useState("");

  return (
    <CalendarCardInfContext.Provider
      value={{ cardInf, setCardInf, btnTyp, setBtnTyp }}
    >
      {children}
    </CalendarCardInfContext.Provider>
  );
};

export const useCalendarCardInfContext = (): CalendarCardInfContextType => {
  const context = useContext(CalendarCardInfContext);

  if (!context) {
    throw new Error(
      "useCalendarCardInfContext는 CalendarProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};
